<template>
<div class="chapter">
<div class="inner_page">
<div class="group">
<p class="C579"><span class="size_235"><strong><span class="Smallcaps"><span id="page_16">DESIGN</span> YOUR OWN</span></strong></span></p>
<p class="C572"><img alt="" src="img/17_1.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 15_Design_Y.vue?0bd3f35e